package kz.dentalcrm.app.screens.positions.list.mvi

import kz.dentalcrm.app.core.base.ViewSideEffect
import kz.dentalcrm.app.data.network.response_model.positions.Position

sealed interface PositionsViewSideEffect : ViewSideEffect {
    data class ShowEditPosition(val position: Position) : PositionsViewSideEffect
}
